import React, { useEffect, useState } from "react";
import axios from "axios";
import { RefreshCw, Sun } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Ida's Morning Brief: the day, already read for you. Cached per day server-side.
export default function MorningBrief() {
  const [brief, setBrief] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const load = async (refresh = false) => {
    refresh ? setRefreshing(true) : setLoading(true);
    try {
      const { data } = await axios.get(`${API}/hq/morning-brief`, { params: refresh ? { refresh: 1 } : {} });
      setBrief(data.brief);
    } catch (e) {
      console.error("morning brief failed", e);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="mt-8 rounded-2xl border border-[#3b568f]/40 bg-[#16223a] p-6 md:p-7" data-testid="hq-morning-brief">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-[10.5px] uppercase tracking-[0.14em] text-[#8fb0e8]">
          <Sun className="w-3.5 h-3.5" /> Ida&rsquo;s Morning Brief
        </div>
        <button
          type="button"
          onClick={() => load(true)}
          className="text-white/30 hover:text-white/70 transition-colors"
          aria-label="Refresh morning brief"
          data-testid="hq-brief-refresh"
        >
          <RefreshCw className={`w-3.5 h-3.5 ${refreshing ? "animate-spin" : ""}`} />
        </button>
      </div>

      {loading && <p className="mt-4 text-white/35 text-[13.5px] animate-pulse">Ida is reading everything…</p>}

      {!loading && brief && (
        <div className="mt-4 space-y-4">
          <p className="font-display font-bold text-white text-[19px] md:text-[21px] tracking-[-0.01em] leading-[1.3]" data-testid="hq-brief-greeting">
            {brief.greeting}
          </p>
          <p className="text-white/75 text-[14.5px] leading-[1.75]" data-testid="hq-brief-body">
            {brief.briefing}
          </p>
          {brief.one_thing && (
            <div className="rounded-xl bg-[#0e1730] border border-[#3b568f]/30 p-4">
              <div className="text-[#8fb0e8] text-[10.5px] uppercase tracking-[0.12em] mb-1.5">The one thing today</div>
              <p className="text-white text-[14.5px] leading-[1.6] font-medium" data-testid="hq-brief-one-thing">{brief.one_thing}</p>
            </div>
          )}
          {Array.isArray(brief.radar) && brief.radar.length > 0 && (
            <div className="flex flex-wrap gap-x-6 gap-y-1.5">
              {brief.radar.map((r, i) => (
                <p key={i} className="text-white/50 text-[13px] leading-[1.6]">· {r}</p>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
